import React from 'react';
import {
  string,
  func
} from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useConfigService, useStore } from '@thd-nucleus/experience-context';
import { CalculatorProvider } from '../CalculatorProvider';
import { getPIPCalculatorProps, shouldDisplayPipCalculator } from '../../../helpers/pipCalculatorHelper';
import { Calculator } from '../../Calculator';
import { pipCalculatorDataModel } from '../../dataModel';
import { Results } from './Results/Results';

export const PIPCalculator = ({ itemId, onCalculate }) => {
  const estimatorEnabled = useConfigService('fs:estimatorEnabled');
  const { storeId } = useStore();

  const { data } = useDataModel('clientOnlyProduct', {
    skip: !itemId,
    ssr: false,
    variables: {
      itemId,
      storeId
    }
  });

  if (estimatorEnabled) {
    return null;
  }

  // todo: see if these empty bracket fallbacks are necessary
  const { product = {} } = data || {};
  const {
    fulfillment = {},
    info = {},
    installServices = {},
    pricing = {}
  } = product;

  if (!shouldDisplayPipCalculator({ fulfillment, info, installServices })) {
    return null;
  }

  const pipCalculatorProps = getPIPCalculatorProps({ info });
  const { calcProps, resultsProps } = pipCalculatorProps;

  return (
    <div data-component="PIPCalculator">
      <CalculatorProvider
        allowAdditionalCoverage
        calculatorType={calcProps.calculatorType}
        info={info}
        lineItemName={calcProps.lineItemName}
        unitsPerCase={resultsProps.unitsPerCase}
      >
        <Calculator
          dimensionNames={calcProps.dimensionNames}
          maxAreaNumber={calcProps.maxAreaNumber}
          onCalculate={onCalculate}
        />
        <Results
          caseUnitOfMeasure={resultsProps.caseUnitOfMeasure}
          pricing={pricing}
          unitsPerCase={resultsProps.unitsPerCase}
          uom={resultsProps.uom}
        />
      </CalculatorProvider>
    </div>
  );
};

PIPCalculator.displayName = 'PIPCalculator';

PIPCalculator.dataModel = pipCalculatorDataModel;

PIPCalculator.propTypes = {
  itemId: string.isRequired,
  onCalculate: func.isRequired
};
